"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { toast } from "sonner";
import { useUserSummary } from "@/lib/api/user";
import { useI18nDebug } from "@/lib/i18n-debug";

/**
 * Registers the `Ctrl+Alt+K` shortcut that toggles the "show translation keys"
 * debug/edit mode (see `useI18nDebug` and `I18nEditOverlay`). Renders nothing.
 *
 * Gated on site admins: the shortcut is a no-op for everyone else, and any
 * flag persisted from a non-admin session is cleared so the mode can only ever
 * be active for an admin (which lets the rest of the app key off the flag alone
 * without re-checking admin).
 */
export function I18nDebugToggle() {
  const $ = _c(8);
  const summary = useUserSummary();
  const isAdmin = !!summary.data?.user?.is_admin;
  const toggle = useI18nDebug(_temp);
  const setEnabled = useI18nDebug(_temp2);
  let t0;
  let t1;
  if ($[0] !== isAdmin || $[1] !== setEnabled) {
    t0 = () => {
      if (isAdmin) {
        return;
      }
      if (useI18nDebug.getState().enabled) {
        setEnabled(false);
      }
    };
    t1 = [isAdmin, setEnabled];
    $[0] = isAdmin;
    $[1] = setEnabled;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== isAdmin || $[5] !== toggle) {
    t2 = () => {
      if (!isAdmin) {
        return;
      }
      const onKeyDown = e => {
        if (e.ctrlKey && e.altKey && !e.shiftKey && !e.metaKey && e.code === "KeyK") {
          e.preventDefault();
          toggle();
          const enabled = useI18nDebug.getState().enabled;
          toast(enabled ? "i18n keys: on" : "i18n keys: off");
        }
      };
      window.addEventListener("keydown", onKeyDown);
      return () => window.removeEventListener("keydown", onKeyDown);
    };
    t3 = [isAdmin, toggle];
    $[4] = isAdmin;
    $[5] = toggle;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  return null;
}
function _temp2(s_0) {
  return s_0.setEnabled;
}
function _temp(s) {
  return s.toggle;
}